<template>
  <div id="app">     
    <notices />
    <md-app md-mode="reveal" :class="{ 'pt-3' : this.isNotices }">
      <md-app-toolbar class="md-primary">
        <div class="back-button">
          <md-button class="md-icon-button" v-show="backVisible" @click="back">
            <md-icon>keyboard_arrow_left</md-icon>
          </md-button>
        </div>
        <!--<h3 class="" style="flex: 1">{{title}}</h3>-->
        <div class="text-align-left" style="flex: 1;" v-if="showShopName">{{shopName}}</div>
        <div class="" style="flex: 1" v-else><nna-logo/></div>        
        <md-button class="md-icon-button" @click="menuVisible = !menuVisible">
          <md-icon>menu</md-icon>
        </md-button>        
      </md-app-toolbar>            
      <md-app-drawer :md-active.sync="menuVisible" :md-right="true">
        <md-list>
          <md-list-item>
            <span class="md-list-item-text"><router-link :to="{ name: 'home' }">Home</router-link></span>
          </md-list-item>
          <!--<md-list-item>
            <span class="md-list-item-text"><router-link :to="{ name: 'home' }">Check-in</router-link></span>
          </md-list-item>-->
          <!--<md-list-item>
            <span class="md-list-item-text"><router-link :to="{ name: 'shops' }">Shops</router-link></span>
          </md-list-item>-->
          <md-list-item v-if="isAuth">
            <span class="md-list-item-text"><router-link :to="{ name: 'orders' }">Ordini</router-link></span>
          </md-list-item>
          <md-list-item v-if="isAuth">
            <span class="md-list-item-text"><router-link :to="{ name: 'cart' }">Carrello</router-link></span>
          </md-list-item>
          <md-list-item v-if="isAuth">
            <span class="md-list-item-text" @click="logout"><router-link :to="{ name: 'auth' }">Logout</router-link></span> 
          </md-list-item>
          <md-list-item v-else>
            <span class="md-list-item-text"><router-link :to="{ name: 'auth' }">Login</router-link></span>
          </md-list-item>                    
        </md-list>
      </md-app-drawer>
      <md-app-content>
        <transition name="fade">
          <nna-loader v-if="loader" />
        </transition>        
        <router-view />
      </md-app-content>
    </md-app>    
    <div class="bottom-bar" v-show="bottomBarVisible">
      <md-bottom-bar md-type="fixed">
        <md-bottom-bar-item :to="productsUrl" id="bottom-bar-item-menu" md-label="Prodotti" md-icon="remove_red_eye"></md-bottom-bar-item>
        <md-bottom-bar-item to="/profile/orders" id="bottom-bar-item-profile" md-label="Profilo" md-icon="account_circle"></md-bottom-bar-item>
        <md-bottom-bar-item to="/cart" id="bottom-bar-item-cart" md-label="Carrello" md-icon="shopping_cart">
          <md-icon>shopping_cart</md-icon>
          <span class="md-bottom-bar-label">Carrello</span>
          <i class="badge" v-if="itemsNumber > 0">{{itemsNumber}}</i>
        </md-bottom-bar-item>
      </md-bottom-bar>    
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Notices from '@/modules/common/components/notices/notices'
import Container from 'vuex'
export default {
  name: 'App',
  data: () => ({
    menuVisible: false,
  }),
  components: {
    Notices
  },
  watch:{
    $route (to, from){
        this.menuVisible = false;
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      currenShopId: 'shops/current_shop_id',
      itemsNumber: 'cart/itemsNumber',
      shop: 'shops/current',
      notices: 'notices/notices',
      loader: 'global/loader',
    }),
    title() {
      let title = this.$route.meta.title
      if(title) return title
      else return "NoNameApp"
    },
    shopName() {
      return this.shop && this.shop.name ? this.shop.name : ''
    },
    showShopName() {
      return this.$route.meta.showShopName
    },      
    backVisible() {
      return this.$route.meta && this.$route.meta.backButton ? this.$route.meta.backButton.enabled : ''
    },
    bottomBarVisible() {
      return this.$route.meta.bottomBar
    },    
    productsUrl(){
      return `/shop/${this.currenShopId}/products`
    },
    isAuth() {
      return this.isAuthenticated
    },
    isNotices(){
      return this.notices
    }
  },  
  methods: {
    async logout() {
      try {
        this.$store.commit("auth/AUTH_LOGOUT")
        this.$router.push({ name: "auth" })
      }
      catch (errors) {
       console.error("Error:", errors)
       this.sending = false
       this.$toasted.show('Qualcosa è andato storto!', { type: 'error' })
      }      
    },
    back() {
      let name = this.$route.meta.backButton.name
      if(name) {
        this.$router.push({ name: name })
      } else {
        this.$router.go(-1)
      }      
    }
  },
}
</script>

<style lang="scss" scoped>
.back-button {
  width: 40px;
  min-width: 40px;
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue